module.exports = " <div class=radio-fieldtype-wrapper> <ul :class=\"[\n        'list-unstyled',\n        config.inline ? 'list-inline mb-0' : ''\n    ]\"> <li v-for=\"option in config.options\" :class=\"{ 'mb-0 mr-2': config.inline }\"> <input type=radio v-model=data :value=option.value :id=\"name + '-' + $index\"/> <label :for=\"name + '-' + $index\">{{ option.text }}</label> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/RadioFieldtype.vue
// module id = 704
// module chunks = 0